<template>
  <input
    type="text"
    class="form-control bg-grad-orange"
    placeholder="Player..."
    v-model.trim="search"
    @keyup.enter="quickSetLive()"
    @keyup.delete="clearLivePlayer()"
  />
  <ul class="list-group" style="z-index: 1055">
    <li
      class="list-group-item bg-grad-orange"
      v-for="p in sorted_players"
      :key="p.id"
    >
      <div
        class="row d-flex align-items-center hoverblue rounded"
        @click="setAsLivePlayer(p.id)"
      >
        <div class="col"><LogoSmall :path="p.pic"></LogoSmall></div>
        <div class="col text-start midtxt">{{ p.name }}</div>
        <div class="col">
          <i class="bi bi-octagon-fill text-danger" v-if="p.team_id"></i>
        </div>
      </div>
    </li>
  </ul>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
const store = useStore();
const search = ref("");
const all_players = ref([]);
const clearLivePlayer = () => {
  if (!search.value.length) clearExistingLivePlayer();
};
const quickSetLive = () => {
  if (sorted_players.value.length) {
    setAsLivePlayer(sorted_players.value[0].id);
  }
};
onMounted(() => {
  setTimeout(() => {
    fetchPlayers();
  }, 1000);
});
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
};
const sorted_players = computed(() => {
  var arr = [];
  all_players.value.forEach((p) => {
    if (search.value.length > 1) {
      if (compareStrings(search.value, p.name)) {
        arr.push(p);
      }
    }
  });
  return arr;
});
// const compareStrings = (needle, haystack) => {
//   var found = false;
//   if (haystack.toLowerCase().includes(needle.toLowerCase())) {
//     found = true;
//   }
//   return found;
// };
const compareStrings = (needle, haystack) => {
  const normalizedNeedle = needle.toLowerCase();
  const normalizedHaystack = haystack.toLowerCase().replace(/\s+/g, "");
  return normalizedHaystack.includes(normalizedNeedle);
};

const setAsLivePlayer = async (id) => {
  clearExistingLivePlayer(); //this is done to trigger a reload of the LivePlayer component
  setTimeout(() => {
    setLivePlayer(id);
    search.value = "";
  }, 200);
  setBiddingOpenToTrue();
};
const clearExistingLivePlayer = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
};
const setLivePlayer = async (id) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: id })
    .eq("id", store.live_auction)
    .select();
};
const setBiddingOpenToTrue = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: true })
    .eq("id", store.live_auction)
    .select();
};
</script>
<style scoped>
.midtxt {
  font-size: 12px;
}
.hoverblue:hover {
  background-color: lightblue;
}
</style>
